<template>
  <NavWrapper
    class="nav"
    to="/contact"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavWrapper from "../../../components/NavWrapper.vue";

export default defineComponent({
  name: "NavSubsection",
  components: {
    NavWrapper
  }
});
</script>

<style>
.nav {
  align-self: stretch !important;
  left: unset !important;
  top: unset !important;
  width: 100% !important;
}
</style>
